import { Box, Flex } from "@chakra-ui/react";
import CDS from "design-system";

interface IntegrationRowProps {
  logo: React.ReactNode;
  name: string;
  description: string;
  status?: React.ReactNode;
  action: React.ReactNode;
  children?: React.ReactNode;
}

export default function IntegrationRow({
  logo,
  name,
  description,
  status,
  action,
  children,
}: IntegrationRowProps) {
  return (
    <Box>
      <Flex align="center" gap="3">
        {logo}
        <Box>
          <CDS.Text12 fontWeight="semibold">{name}</CDS.Text12>
          <CDS.Text10 color="fg.subtle" mt="0.5">{description}</CDS.Text10>
        </Box>
        {status}
        {action}
      </Flex>
      {children && <Box mt="3" ml="11">{children}</Box>}
    </Box>
  );
}
